import React, { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { getSecciones } from "../../../API/RRHH/Secciones/SeccionesRequests";
import MultiSelectDropdown from "../../../Base/Components/Form/MultiSelectDropdown";
import { getPersonalSinToken } from "../../../API/RRHH/Personal/PersonalRequests";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { InputTextarea } from "primereact/inputtextarea";
import { editarQrMarcaje, getListQr, guardarQrMarcaje } from "../../../API/RRHH/Marcaje/QRMarcasRequest";
import { toastShow } from "../../../Base/Services/ToastService";
import { Checkbox } from "primereact/checkbox";

const QRMarcajeCrud = ({
  visible,
  setVisible,
  qrMarcajes,
  getinfo = () => {},
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [secciones, setSecciones] = useState([]);
  const [selectedItemsSecciones, setSelectedItemsSecciones] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [selectedItemsPersonal, setSelectedItemsPersonal] = useState([]);

  const initialValues = {
    IdQR: -1,
    IdPersonal: null,
    Description: null,
    Universal: false
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =useForm(initialValues);

  
  const getInfoForm = async () => {
    setLoading(true);
  
    const listSecciones = await getSecciones();
    setSecciones(listSecciones);
    
    const listPersonal = await getPersonalSinToken();
    setPersonal(listPersonal);
  
    if (qrMarcajes) {
      const listQR = await getListQr();
      
      // Filtrar la lista de QR
      const filteredQR = listQR.find((qr) => qr.IdQR === qrMarcajes);
  
      // Obtener las secciones seleccionadas
      const seccionesSeleccionadas = listSecciones.filter((s) => 
        filteredQR.IdSecciones?.split(",").includes(s.CodigoSeccion)
      );

      // Obtener personal seleccionado
      const personalSeleccionado = listPersonal.filter((s) => 
        filteredQR.IdPersonales?.split(",").map(id => id.trim()).includes(s.idpersonal)
      );
  
      // Asignar valores al formulario
      setValues({
        ...filteredQR,
      });
  
      setSelectedItemsSecciones(seccionesSeleccionadas);
      setSelectedItemsPersonal(personalSeleccionado);
    }
    
    setLoading(false);
  };

  const verificarCampos = () => {
    let error = false;
  
    if (selectedItemsSecciones.length === 0) {
      toastShow(toast, "warn", "Error", "Seleccione al menos una sección.");
      error = true;
    }
  
    // if (selectedItemsPersonal.length === 0) {
    //   toastShow(toast, "warn", "Error", "Seleccione al menos un personal.");
    //   error = true;
    // }
  
    // if (!values.Descripcion || values.Descripcion.trim() === "") {
    //   toastShow(toast, "warn", "Error", "Ingrese una descripción.");
    //   error = true;
    // }
  
    return error;
  };
  

  const agregarQR = async () => {
    if (verificarCampos()) {
        return;
    }

    // setLoading(true);
    const idsPersonalIPS = selectedItemsPersonal.map((e) => e.idpersonal).join(",");
    const IdSeccionesIPS = selectedItemsSecciones.map((e) => e.CodigoSeccion).join(",");

    const Datos = {
      IdQR: values?.IdQR,
      Data: "",
      IdUserCreate: userAuth?.idUser,
      Descripcion: values?.Descripcion,
      Universal: values?.Universal,
      IdUserEdit: userAuth?.idUser,
    };

    const DetallePersonal = {
      IdPersonal: idsPersonalIPS,
      IdUserCreate: userAuth?.idUser,
    };

    const DetalleSeccion = {
      IdSeccion: IdSeccionesIPS,
      IdUserCreate: userAuth?.idUser,
    };

    if(qrMarcajes){
      const res = await editarQrMarcaje(Datos, DetallePersonal, DetalleSeccion);
      if (res[0]?.ESTADO === 1) {
        setLoading(true);
        toastShow(toast, "success", "Datos Editados", res[0].MENSAJE);
        getinfo();
        setTimeout(() => {
          onHide();
          setLoading(false);
        }, 1500);
      } else {
        toastShow(toast, "error", "Error", res[0].MENSAJE);
      }
    }else{
      const res = await guardarQrMarcaje(Datos, DetallePersonal, DetalleSeccion);
      if (res[0]?.ESTADO === 1) {
        setLoading(true);
        toastShow(toast, "success", "Datos Agregados", res[0].MENSAJE);
        getinfo();
        setTimeout(() => {
          onHide();
          setLoading(false);
        }, 1500);
      } else {
        toastShow(toast, "error", "Error", res[0].MENSAJE);
      }
    }
  };

  const onHide = () => {
    setVisible(false);
    resetForm();
    setSelectedItemsPersonal([]);
    setSelectedItemsSecciones([]);
  };

  useEffect(() => {
    if (visible) {
      getInfoForm();
    }
  }, [visible]);

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarQR();
        }}
      />
    </React.Fragment>
  );
  
  const headerCrud = qrMarcajes ? "Editar QR" : "Agregar QR";

  return (
    <Dialog
      header={headerCrud}
      visible={visible}
      style={{ width: "50vw" }}
      footer={DialogFooter}
      onHide={onHide}
    >
      <div id="Dialog">
        <Loader loading={loading} querySelector={"#Dialog"} />
        <Toast ref={toast} />
        <div className="field mt-2">
          <span className="p-float-label">
            <MultiSelectDropdown
              name="Secciones"
              value={selectedItemsSecciones}
              setValue={setSelectedItemsSecciones}
              items={secciones}
              field="Seccion"
              placeholder="Seleccione Sección"
              label="Sección"
            />
          </span>
        </div>

        <div className="field mt-4">
          <span className="p-float-label">
            <MultiSelectDropdown
              enable={selectedItemsSecciones ? true : false}
              name="Personal"
              value={selectedItemsPersonal}
              setValue={setSelectedItemsPersonal}
              items={personal}
              field="CodigoNombre"
              placeholder="Seleccione personal"
              label="Personal"
            />
          </span>
        </div>

        <div className="field d-flex col-12 mt-4">
          <span className="p-float-label">
            <InputTextarea
              id="Descripcion"
              name="Descripcion"
              value={values.Descripcion}
              onChange={handleInputChange}
              autoResize={true}
              cols={73}
              placeholder
              className={"p-inputtext-sm block mb-2 mx-1 block"}
            />
            <label htmlFor="TipoCompra">Descripción</label>
          </span>

          <div className="mx-auto" style={{marginTop:30}}>
            <Checkbox
              inputId="Universal"
              name="Universal"
              value={values.Universal}
              onChange={(e) =>
                handleInputChange({ target: { value: !values.Universal } }, "Universal")
              }
              checked={values.Universal}
            />
            <label htmlFor="Universal" style={{ marginLeft: '4px' }}>Universal</label>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default QRMarcajeCrud;